import { isAllowedRedirectUrl } from '../../../backend/src/feature/Client/redirectUrls';

/**
 * Validate the redirect URL a client asked for.
 *
 * This used to be a request to the backend, which made every login wait on a round trip and left
 * terminals on a spinner when it could not be made. The check is the same function the backend
 * uses, bundled in: the frontend is what performs the redirect, so asking the backend first added
 * no protection.
 */
const useRedirectUrl = (
  userInputRedirectUrl: string | null,
  clientId: string | null
) => {
  if (!userInputRedirectUrl || !clientId) {
    return { redirectUrl: undefined, redirectUrlError: undefined };
  }

  return isAllowedRedirectUrl(clientId, userInputRedirectUrl)
    ? { redirectUrl: userInputRedirectUrl, redirectUrlError: false }
    : { redirectUrl: undefined, redirectUrlError: true };
};

export default useRedirectUrl;
